import { QuappSplash } from './QuappSplash'

interface LoadingStateProps {
  /** Slug of the Quapp being opened — used to show its icon on the splash. */
  slug?: string
}

/**
 * Full-screen branded splash shown while the Quapp's data loads.
 * Shows the Quapp's own icon on white with a subtle "powered by Quapp" mark.
 */
export function LoadingState({ slug }: LoadingStateProps) {
  const iconSrc = slug ? `/m/icons/${slug}-512.png` : undefined
  return (
    <div className="fixed inset-0 bg-white">
      <QuappSplash iconSrc={iconSrc} />
    </div>
  )
}
